import { Loader } from '@components/loader';
import { useGetApiKey } from '@services/merchant/apiKeys/get';
import { createFileRoute, redirect, useNavigate, useParams } from '@tanstack/react-router';
import { ApiKeyShow } from '@pages/apiKeys/id';
import { useDisableApiKey } from '@services/merchant/apiKeys/disable';
import { useGetPermissionGroups } from '@services/merchant/apiKeys/permissionsGroups';

const ShowApiKey = () => {
  const { id, localId } = useParams({ from: '/u/$localId/_merchant/merchant/api-keys/$id/' });
  const navigate = useNavigate();
  const { data, isPending } = useGetApiKey(id);
  const { mutate, isPending: disabling } = useDisableApiKey();
  const { data: permissions } = useGetPermissionGroups();

  if (isPending) return <Loader />;

  return (
    <ApiKeyShow
      apiKey={data}
      onDisable={mutate}
      disabling={disabling}
      permissions={permissions}
      handleDuplicateRedirect={() => {
        navigate({
          to: '/u/$localId/merchant/api-keys/new',
          params: { localId },
          search: { duplicateFrom: data.id },
        }).catch((err) => console.error(err));
      }}
    />
  );
};

export const Route = createFileRoute('/u/$localId/_merchant/merchant/api-keys/$id/')({
  beforeLoad: ({ context }) => {
    if (!context.userHasPermissions(['api_keys_read'])) {
      throw redirect({
        to: `/u/$localId/${context.userType}/forbidden`,
      });
    }
  },
  component: ShowApiKey,
});
